// Utilidades para notificaciones nativas del navegador (Web Notifications API).
// Se usan para avisar de incidencias nuevas en tiempo real (ver useIncidentNotifications).

export const notificationsSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window

// 'granted' | 'denied' | 'default' | 'unsupported'
export const getNotificationPermission = () =>
  notificationsSupported() ? Notification.permission : 'unsupported'

// Pide permiso al usuario. Debe llamarse desde un gesto (clic) para que el
// navegador muestre el prompt. Devuelve el estado resultante.
export const requestNotificationPermission = async () => {
  if (!notificationsSupported()) return 'unsupported'
  if (Notification.permission === 'granted') return 'granted'
  try {
    return await Notification.requestPermission()
  } catch {
    return Notification.permission
  }
}

// Muestra una notificación nativa si hay permiso. Devuelve la Notification o null.
// onClick: callback al pulsar la notificación (p.ej. navegar a la incidencia).
export const showBrowserNotification = ({ title, body, tag, onClick } = {}) => {
  if (getNotificationPermission() !== 'granted') return null
  try {
    const n = new Notification(title || 'Notificación', {
      body: body || '',
      tag,                 // agrupa/sustituye notificaciones con el mismo tag
      icon: '/logo_cs.png',
    })
    if (typeof onClick === 'function') {
      n.onclick = (event) => {
        event.preventDefault()
        try { window.focus() } catch { /* noop */ }
        onClick()
        n.close()
      }
    }
    return n
  } catch {
    return null
  }
}
